import { ActionButton } from '@library/components/buttons';
import { PATHS } from '@bo-constants/routes';
import { PageHeader } from '@library/components/layout/PageHeader';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export interface PlayerPacksHeaderProps {
  children?: React.ReactNode;
  title: string;
}

export const PlayerPackDetailsHeader = ({
  children = undefined,
  title
}: PlayerPacksHeaderProps) => {
  const navigate = useNavigate();

  const handleOnClick = useCallback(() => {
    navigate(PATHS.PLAYER_PACKS);
  }, [navigate]);

  return (
    <PageHeader moduleName="Entities" title={title}>
      <div className="flex items-center gap-4">
        <ActionButton
          variant="secondary"
          dataTestId="return-to-player-packs-home"
          handleOnClick={handleOnClick}
          title="Return to Player Packs"
        >
          Back
        </ActionButton>
        {children}
      </div>
    </PageHeader>
  );
};
